import React from "react";
import {
    Pagination as PaginationUI,
    PaginationContent,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "@/components/common/table/pagination";
import { cn } from "@/utils/css";

export const Pagination = ({
    currentPage,
    totalPages,
    itemsPerPage,
    totalItems,
    onPageChange,
    className = "",
    showItemsInfo = true,
    itemsLabel = "items",
}) => {
    if (totalPages <= 1) return null;

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

    const renderPageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3);
                pages.push("ellipsis");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push("ellipsis");
                for (let i = totalPages - 3; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1);
                pages.push("ellipsis");
                pages.push(currentPage - 1, currentPage, currentPage + 1);
                pages.push("ellipsis");
                pages.push(totalPages);
            }
        }

        return pages.map((page, index) => (
            <PaginationItem key={index}>
                {page === "ellipsis" ? (
                    <span className="flex h-9 w-9 items-center justify-center text-cm-p-text-secondary">...</span>
                ) : (
                    <PaginationLink
                        onClick={() => onPageChange(page)}
                        isActive={currentPage === page}
                        className="cursor-pointer rounded-[6px] w-[38px] h-[38px]"
                    >
                        {page}
                    </PaginationLink>
                )}
            </PaginationItem>
        ));
    };

    return (
        <div className={cn("flex justify-center items-center w-full h-10", className)}>
            <div className="flex items-center mx-auto w-full justify-center">
                <PaginationUI className="relative w-auto">
                    <PaginationContent>
                        <PaginationItem>
                            <PaginationPrevious
                                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                                className={cn("cursor-pointer w-[38px] h-[38px]", currentPage === 1 && "pointer-events-none opacity-50")}
                            />
                        </PaginationItem>

                        {renderPageNumbers()}

                        <PaginationItem>
                            <PaginationNext
                                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                                className={cn(
                                    "cursor-pointer w-[38px] h-[38px]",
                                    currentPage === totalPages && "pointer-events-none opacity-50",
                                )}
                            />
                        </PaginationItem>
                    </PaginationContent>
                    {showItemsInfo && (
                        <span className="text-cm-p-text-secondary text-sm/[22px] whitespace-nowrap absolute left-full ml-4 top-1/2 -translate-y-1/2">
                            Showing {startIndex + 1}-{endIndex} of {totalItems} {itemsLabel}
                        </span>
                    )}
                </PaginationUI>
            </div>
        </div>
    );
};
